import AppBar from "@material-ui/core/AppBar";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import InputBase from "@material-ui/core/InputBase";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import companylogo from "../../../assets/images/companylogo.svg";
import plusicon from "../../../assets/images/plusicon.svg";
import searchicon from "../../../assets/images/searchicon.svg";
import { BaseUrl } from "../../../Environment";
import { withNamespaces } from "react-i18next";
import "./AllNewCustomerHeader.scss";
import { getSecureItem } from "../../../utilsFunctions";

const axios = require("axios");

class AllNewCustomerHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      allCustomer: [],
      searchValue: "",
      searchSuggestions: [],
      showSuggestions: false,
    };
  }
  componentDidCatch(error, info) {
    // Catch errors in any components below and re-render with error message
    console.log("componentDidCatch");
    console.log(error);
    console.log(info);
    this.setState({
      error: error,
      errorInfo: info,
    });
    // You can also log error messages to an error reporting service here
  }
  addcustomer() {
    this.props.history.push("/customers/addcustomer");
  }
  csvImportExport() {
    this.props.history.push("/customers/csvImportExport");
  }
  handleSearch = () => {
    const { searchValue } = this.state;

    if (!searchValue.trim()) {
      this.setState({
        searchSuggestions: [],
        showSuggestions: false,
      });
      this.props.reciveData([]);
      return;
    }

    let loggedinUser = getSecureItem("loggedinUserCompany");

    const headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + getSecureItem("token"),
    };

    axios
      .get(
        BaseUrl +
        "/customer/getAllCustomers?name=" +
        searchValue +
        "&companyId=" +
        loggedinUser,
        { headers },
      )
      .then((resp) => {
        if (resp.status === 200) {
          resp.data.forEach((item) => {
            item.count = item.loans ? Object.keys(item.loans).length : 0;
          });

          this.setState({
            searchSuggestions: resp.data,
            showSuggestions: true,
          });
        }
      });
  };
  selectSuggestion = (customer) => {
    this.setState({
      searchValue: `${customer.firstName} ${customer.lastName}`,
      showSuggestions: false,
      searchSuggestions: [],
    });

    this.props.reciveData([customer]);
  };
  closeSuggestions = () => {
    setTimeout(() => {
      this.setState({
        showSuggestions: false,
      });
    }, 150);
  };
  handleSearchInputChange = (e) => {
    this.setState({
      searchValue: e.target.value,
    });
  };

  render() {
    const { t } = this.props;

    const userPermissions = getSecureItem("UsersAccess");
    return (
      <div className="allCustomerHeader">
        <section className="Customerheader">
          <AppBar position="static" className="bar">
            <Toolbar className="rowColumn">
              <Typography
                variant="h6"
                className="title"
                style={{ width: "67%" }}
              >
                <img src={companylogo} alt="logo" />
              </Typography>
              <div className="searchDiv">
                <IconButton
                  className="iconButton"
                  aria-label="search"
                  onClick={this.handleSearch}
                >
                  <img
                    src={searchicon}
                    alt="searchicon"
                    className="iconButton"
                  />
                </IconButton>

                <InputBase
                  className="input"
                  placeholder="Search Borrower"
                  value={this.state.searchValue}
                  onChange={this.handleSearchInputChange}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      this.handleSearch();
                    }
                  }}
                  onBlur={this.closeSuggestions}
                  onFocus={() => {
                    if (this.state.searchSuggestions.length) {
                      this.setState({ showSuggestions: true });
                    }
                  }}
                />
                {this.state.showSuggestions &&
                  this.state.searchSuggestions.length > 0 && (
                    <ul className="customerSearchDropdown">
                      {this.state.searchSuggestions.map((customer) => (
                        <li
                          key={customer.customerId}
                          className="customerSearchDropdownItem"
                          onMouseDown={() => this.selectSuggestion(customer)}
                        >
                          <span>
                            {customer.firstName} {customer.lastName}
                          </span>

                          <span className="customerSearchDropdownSub">
                            {customer.cust_id}
                            {customer.phone ? ` • ${customer.phone}` : ""}
                          </span>
                        </li>
                      ))}
                    </ul>
                  )}
              </div>
            </Toolbar>
          </AppBar>
        </section>

        {/* <div style={{marginLeft: 75}} className="ButtonDiv">
                <Button className="Fonts btnSizeFont adduserbutton" onClick={this.csvImportExport.bind(this)}>
                  {"CSV Import/Export"}
                </Button>
              </div> */}

        <section className="Headerthing">
          {userPermissions?.addBorrowers && (
            <div style={{ display: "flex", flexDirection: "row" }}>
              <div className="ButtonDiv" style={{ marginRight: 200 }}>
                <Button
                  className="Fonts btnSizeFont adduserbutton"
                  onClick={this.csvImportExport.bind(this)}
                >
                  <img
                    src={plusicon}
                    alt="plusicon"
                    className="plusiconButton"
                  />
                  {"Import Borrowers"}
                </Button>
              </div>
              <div className="ButtonDiv">
                <Button
                  className="Fonts btnSizeFont adduserbutton"
                  onClick={this.addcustomer.bind(this)}
                >
                  <img
                    src={plusicon}
                    alt="plusicon"
                    className="plusiconButton"
                  />
                  {t("NewCustomer.addbutton")}
                </Button>
              </div>
            </div>
          )}
        </section>
      </div>
    );
  }
}
export default withNamespaces()(withRouter(AllNewCustomerHeader));
